class PDPAlternatingPanels{
    static instance = null;

    blocks = null;

    videoPlayers = {};

    static getInstance() {
        if (PDPAlternatingPanels.instance === null) {
            PDPAlternatingPanels.instance = new PDPAlternatingPanels();
        }
        return PDPAlternatingPanels.instance;
    }

    init(){
        if(Electro.DEBUG) {
            console.log('PDPAlternatingPanels.init');
        }

        this.blocks = document.querySelectorAll('.b-pdp-alternating-panels');
        this.videoPlayers = {};

        // Load Youtube
        this.loadYoutube();
    }

    loadYoutube() {
        // Only load YouTube API if not already loaded
        if (window.YT) {
            this.initializeVideoPlayers();
            return;
        }

        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        tag.className = 'optanon-category-C0004';
        tag.type='text/plain';

        // Add event listener for when API is ready
        window.onYouTubeIframeAPIReady = () => {
            this.initializeVideoPlayers();
        };

        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    initializeVideoPlayers() {
        this.blocks.forEach(block => {
            // Does it support video?
            const videoWrapper = block.querySelector('.video__player');
            const playButton = block.querySelector('.js-play-video');
            if(!videoWrapper) return;


            const { youtubeId } = videoWrapper.dataset;
            const playerId = videoWrapper.id;
            if (!youtubeId || !playerId) return;

            this.createYouTubePlayer(youtubeId, playerId, block.id).then(() => {
                // Hide .video__thumbnail when clicked on the block
                playButton.addEventListener('click', (event) => {
                    if (block.querySelector('.video__thumbnail')) {
                        block.querySelector('.video__thumbnail').style.display = 'none';

                        const player = Electro.PDPAlternatingPanels.videoPlayers[block.id];
                        // console.log('Player state:', player.getPlayerState());

                        // Play that video
                        if (this.videoPlayers?.[block.id]) {
                            // console.log(this.videoPlayers[block.id]);
                            this.videoPlayers[block.id].playVideo();
                        }
                    }
                });
            });


        });
    }

    async createYouTubePlayer(youtubeId, playerId, blockId) {
        return new Promise((resolve) => {
            // Make sure the element exists
            const playerElement = document.getElementById(playerId);
            if (!playerElement) {
                if(Electro.DEBUG) {
                    console.error(`Player element with ID ${playerId} not found`);
                }
                return;
            }

            const onPlayerReady = (event, blockId) => {
                // Store the player reference properly
                if (!this.videoPlayers?.[blockId]) {
                    this.videoPlayers[blockId] = event.target;
                }

                resolve(this.videoPlayers[blockId]);
            }

            new YT.Player(playerId, {
                height: '680',
                width: '100%',
                videoId: youtubeId,
                events: {
                    'onReady': (event) => onPlayerReady(event, blockId)
                },
                playerVars: {
                    autoplay: 0,
                    controls: 1,
                    rel: 0,
                    playsinline: 1
                }
            });
        });

    }

}

window.addEventListener('DOMContentLoaded', () => {
    // If image text block does not exist, then exit
    const isPDPAlternatingPanels = document.querySelector('.b-pdp-alternating-panels')
    if(!isPDPAlternatingPanels) return;

    // If the instance already exists, then return
    if(window.Electro.PDPAlternatingPanels) return;

    // Create the instance and initialize
    window.Electro.PDPAlternatingPanels = PDPAlternatingPanels.getInstance();
    window.Electro.PDPAlternatingPanels.init();
});